export default class ColumnRowCard {
  constructor(fieldName, titleName, slotName) {
    this.fieldName = fieldName || "";
    this.titleName = titleName || "";
    this.slotName = slotName || "";

    this.titleStyle = {};
    this.dataStyle = {};
  }

  setColumnStyle(width, optionsTitle, optionsData) {
    this.titleStyle.width = width;
    this.dataStyle.width = width;

    if (optionsTitle && optionsTitle instanceof Object) {
      for (let option in optionsTitle) {
        this.titleStyle[option] = optionsTitle[option];
      }
    }

    if (optionsData && optionsData instanceof Object) {
      for (let option in optionsData) {
        this.dataStyle[option] = optionsData[option];
      }
    }
  }
}
